'use strict';

export default function saCarouselControl() {
  return {
    restrict: 'A',
    require: ['saCarouselControl', '^saCarousel'],
    scope: true,
    controllerAs: 'ctrl',
    controller: [
      function () {
        this.init = function (saCarousel) {
          this.saCarousel = saCarousel;
          this.items = saCarousel.items;
        };
      }
    ],
    link: function ($scope, $element, $attrs, ctrls) {
      ctrls[0].init(ctrls[1]);
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/common/carousel/carousel_control.directive.js